import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  opacity: 0;\n  height: 0px;\n  position: absolute;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/* eslint-disable fp/no-mutation */
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

function copyNodeStyle(sourceNode, targetNode) {
  var computedStyle = typeof window !== "undefined" && window.getComputedStyle(sourceNode);
  Array.from(computedStyle).forEach(function (key) {
    return key.indexOf('font-') === 0 && targetNode.style.setProperty(key, computedStyle.getPropertyValue(key), computedStyle.getPropertyPriority(key));
  });
}

var Measurable = styled(function (_ref) {
  var value = _ref.value,
      _ref$targetRefs = _ref.targetRefs,
      targetRefs = _ref$targetRefs === void 0 ? [] : _ref$targetRefs,
      _ref$extraOffset = _ref.extraOffset,
      extraOffset = _ref$extraOffset === void 0 ? 0 : _ref$extraOffset,
      styleRef = _ref.styleRef,
      other = _objectWithoutProperties(_ref, ["value", "targetRefs", "extraOffset", "styleRef"]);

  var measurableRef = useRef();
  useEffect(function () {
    if ((styleRef === null || styleRef === void 0 ? void 0 : styleRef.current) && measurableRef.current) {
      ;
      measurableRef.current.setAttribute('style', '');
      copyNodeStyle(styleRef.current, measurableRef.current);
    }

    if (measurableRef.current) {
      var el = measurableRef.current;
      el.innerHTML = value;
      var width = el.offsetWidth + extraOffset;

      if (width) {
        targetRefs.forEach(function (targetRef) {
          var _ref2;

          var targetEl = (_ref2 = targetRef) === null || _ref2 === void 0 ? void 0 : _ref2.current;
          if (targetEl) targetEl.style.width = "".concat(width, "px");
        });
      }
    }
  }, [targetRefs, styleRef, value, extraOffset]);
  return /*#__PURE__*/React.createElement("div", _extends({}, other, {
    ref: measurableRef
  }));
})(_templateObject());
export default Measurable;